module.exports = __webpack_public_path__ + "static/aws-eb8653d73a8814c9c4c1441accb2e8b9.png";